module.exports = __webpack_public_path__ + "img/no-products.2ab62b26.png";